import { AnalyticsEffects } from './analytics.effects';
import { AuthAnalyticsEffects } from './auth-analytics.effects';
import { CartAnalyticsEffects } from './cart-analytics.effects';
import { CatalogAnalyticsEffects } from './catalog-analytics.effects';
import { CityAnalyticsEffects } from './city-analytics.effects';
import { ManualPriceAnalyticsEffects } from './manual-price-analytics.effects';
import { SearchAnalyticsEffects } from './search-analytics.effects';

export const effects: any[] = [
  ManualPriceAnalyticsEffects,
  CartAnalyticsEffects,
  CatalogAnalyticsEffects,
  CityAnalyticsEffects,
  SearchAnalyticsEffects,
  AuthAnalyticsEffects,
  AnalyticsEffects,
];
